import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"];

  connect() {
    this.ids = this.linkTargets
      .map((link) => link.getAttribute("href")?.replace("#", ""))
      .filter(Boolean);
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll);
  }

  scroll(event) {
    event.preventDefault();
    const href = event.currentTarget.getAttribute("href");
    const id = href?.replace("#", "");
    const el = id && document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  onScroll() {
    let active = this.ids[0];
    for (const id of [...this.ids].reverse()) {
      const el = document.getElementById(id);
      if (el && el.getBoundingClientRect().top <= 130) {
        active = id;
        break;
      }
    }

    this.linkTargets.forEach((link) => {
      const on = link.getAttribute("href") === `#${active}`;
      link.classList.toggle("border-accent", on);
      link.classList.toggle("text-primary", on);
      link.classList.toggle("border-transparent", !on);
      link.classList.toggle("text-muted-foreground", !on);
    });
  }
}
